import { styled, useMediaQuery, useTheme } from "@mui/material";
import React, { ReactNode } from "react";

type PageContainerProps = {
  children?: ReactNode;
  hasBottomMenu?: boolean;
  isReadOnly?: boolean;
};

type PageContainerStyleProps = {
  isXSmall: boolean;
  isReadOnly?: boolean;
  hasBottomMenu?: boolean;
};

const RootContainer = styled("div", {
  shouldForwardProp: prop => prop !== "isXSmall" && prop !== "hasBottomMenu"
})<PageContainerStyleProps>(({ isXSmall, hasBottomMenu }) => ({
  marginTop: "70px",
  marginBottom: isXSmall && hasBottomMenu ? "55px" : "0px",
  width: isXSmall ? "100%" : "calc(100% - 75px)",
  minHeight: "calc(100vh - 70px)"
}));

const PageContainer = (props: PageContainerProps) => {
  const isXSmall = useMediaQuery(useTheme().breakpoints.down("xs"));

  return (
    <RootContainer
      isXSmall={isXSmall || (props.isReadOnly ?? false)}
      hasBottomMenu={props.hasBottomMenu}
    >
      {props.children}
    </RootContainer>
  );
};

export default PageContainer;
